const esc = (s) => String(s ?? "")
  .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

const civilBoxes = (id) => {
  const cells = (id || "").toString().replace(/\D/g, "").padStart(10, " ").slice(-10).split("").reverse();
  return cells.map((d) => `<td class="digit">${esc(d.trim())}</td>`).join("");
};

const DEDUCTION_STYLES = `
  @page { size: A4 portrait; margin: 8mm 12mm; }
  * { box-sizing: border-box; margin: 0; }
  body { font-family: 'Amiri', 'Traditional Arabic', 'Sakkal Majalla', 'Segoe UI', Tahoma, sans-serif; color: #000; }
  .brand { display: grid; grid-template-columns: 1fr 1fr 1fr; align-items: center; justify-items: center; }
  .brand-divider { border-top: 2.2px solid #064E3B; border-bottom: 0.9px solid #064E3B; height: 3px; margin: 3px 0 6px; }
  .brand .lines { display: flex; flex-direction: column; align-items: center; justify-content: center; align-self: stretch; text-align: right; font-weight: bold; font-size: 14px; line-height: 1.6; }
  h1.dtitle { text-align: center; font-size: 25px; font-weight: bold; margin: 0 0 10px; }
  table { width: 100%; border-collapse: collapse; margin-bottom: 8px; }
  .box td { border: 2.5px solid #000; padding: 3px 10px; }
  .box .lbl { width: 150px; text-align: center; font-weight: bold; font-size: 17px; background: #DCE6F1; }
  td.digit { border: 2.5px solid #000; width: 30px; height: 36px; text-align: center; font-weight: bold; font-size: 16px; }
  .info th, .info td { border: 2.5px solid #000; padding: 4px 6px; text-align: center; font-size: 15px; line-height: 1.5; }
  .info th { font-weight: bold; background: #DCE6F1; }
  .body-p { text-align: justify; font-size: 15.5px; line-height: 1.9; margin: 6px 0; }
  .clause { text-align: justify; font-size: 16px; font-weight: bold; line-height: 1.9; margin: 6px 0; }
  .sigrow { display: flex; justify-content: space-between; margin: 8px 0 0; font-size: 15px; }
  .stamp-img { max-height: 110px; max-width: 180px; object-fit: contain; vertical-align: middle; }
  .mgr-sig { display: inline-block; vertical-align: middle; max-height: 90px; max-width: 260px; object-fit: contain; margin: -30px 0; }
  .notes { margin-top: 14px; font-size: 12.5px; line-height: 1.8; }
`;

const brandHtml = (branding) => `
  <div class="brand">
    <div class="lines">
      <div>${esc(branding.line1 || "المملكة العربية السعودية")}</div>
      <div>${esc(branding.line2 || "وزارة التعليم")}</div>
      ${branding.line3 ? `<div>${esc(branding.line3)}</div>` : ""}
    </div>
    <div>${branding.logo_ministry ? `<img src="${branding.logo_ministry}" style="width:150px;height:150px;object-fit:contain">` : ""}</div>
    <div>${branding.logo_school ? `<img src="${branding.logo_school}" style="width:125px;height:125px;object-fit:contain">` : ""}</div>
  </div>
  <div class="brand-divider"></div>`;

const signatureHtml = (dec, branding, managerName) => `
<p class="body-p" style="text-align:center">والله الموفق</p>

<p class="body-p" style="font-weight:bold">الرئيس المباشر</p>
<div class="sigrow"><span>الاسم : ${esc(managerName)}</span></div>
<div class="sigrow"><span>التوقيع : ${(branding && branding.signature) ? `<img class="mgr-sig" src="${branding.signature}" alt="التوقيع">` : "......................"}</span><span>التاريخ : &nbsp;&nbsp; / &nbsp;&nbsp; / 14&nbsp;&nbsp;هـ</span></div>
${(branding && branding.stamp) ? `<div class="sigrow"><span>الختم : <img class="stamp-img" src="${branding.stamp}" alt="الختم"></span><span></span></div>` : `<p class="body-p">الختم</p>`}

<div class="notes">
${dec.kind === "absence" ? "ملاحظة / لن يتم استلام قرار الحسم بدون المساءلة<br>" : ""}
صورة / للموظفين لمتابعة تنفيذ الحسم ( تنفيذ الأنظمة )<br>
صورة / لمكتب التعليم<br>
صورة / لملفه بالمدرسة
</div>`;

const absencePage = (dec, school) => {
  const emp = dec.employee_info || {};
  const dates = (dec.dates || []).join(" ، ");
  return `
<table class="info">
  <tr><th>الاسم</th><th>التخصص</th><th>المستوى / المرتبة</th><th>الدرجة</th><th>رقم الوظيفة</th><th>عدد أيام الغياب</th></tr>
  <tr>
    <td>${esc(dec.employee_name)}</td>
    <td>${esc(emp.specialty || "")}</td>
    <td>${esc(emp.rank_level || "")}</td>
    <td></td>
    <td>${esc(emp.job_number || "")}</td>
    <td>${esc(dec.days || 1)}</td>
  </tr>
  <tr><td style="background:#DCE6F1;font-weight:bold">الأيام الواجب حسمها ليحدد التاريخ</td>
      <td colspan="5">${esc(dates || dec.period || "")}</td></tr>
</table>

<p class="body-p">إنا مدير المدرسة / ${esc(school || "..............................")}</p>
<p class="body-p">و بناءً على صلاحياته ، وبناءً على المادة ( 21 ) من نظام الخدمة المدينة ، وبناءً على موافقة معالي الوزير على إعطاء بعض الصلاحيات للمدراء بالقرار رقم 1/1139 وتاريخ 1421/3/17هـ ، ولغياب الموظف الموضح اسمه أعلاه ، وحيث إن عذره غير مقبول ، وبمقتضى النظام يُقرر ما يلي :</p>
<p class="clause">[1] حسم مدة الغياب الموضحة بعاليه وعددها ( ${esc(dec.days || 1)} ) يوماً من راتبه</p>
<p class="clause">[2] على إدارة شؤون الموظفين [ تنفيذ الأنظمة ] تنفيذ إجراء الحسم واستبعادها من خدماته وأصل القرار لملفه بالإدارة مع الأساس لملفه ( )</p>`;
};

const latenessPage = (dec, school) => {
  const emp = dec.employee_info || {};
  const hours = dec.total_minutes ? (dec.total_minutes / 60).toFixed(dec.total_minutes % 60 ? 1 : 0) : "";
  return `
<table class="info">
  <tr><th>الاسم</th><th>التخصص</th><th>المستوى / المرتبة</th><th>رقم الوظيفة</th><th>العمل الحالي</th></tr>
  <tr>
    <td>${esc(dec.employee_name)}</td>
    <td>${esc(emp.specialty || "")}</td>
    <td>${esc(emp.rank_level || "")}</td>
    <td>${esc(emp.job_number || "")}</td>
    <td>${esc(emp.current_job || emp.department || "")}</td>
  </tr>
</table>

<p class="body-p">إن مدير المدرسة ${esc(school || "..............................")}</p>
<p class="body-p">و بناءً على صلاحياته ، وبناءً على المادة ( 21 ) من نظام الخدمة المدينة ، وبناءً على موافقة معالي الوزير على إعطاء بعض الصلاحيات للمدراء بالقرار رقم 37617168 وتاريخ 1437/4/1هـ ، ولبلوغ ساعات التأخر عن الدوام والخروج المبكر من الدوام ( ${esc(hours)} ) ساعة وحيث إن عذره غير مقبول وبمقتضى النظام .</p>
<p class="clause" style="text-align:center">يُقرر ما يلي :</p>
<p class="clause">[1] حسم مدة الغياب الموضحة بعاليه وعددها ( ${esc(dec.days || 1)} ) يوماً من راتبه .</p>
<p class="clause">[2] على إدارة شؤون الموظفين [ تنفيذ الأنظمة ] تنفيذ إجراء الحسم واستبعادها من خدماته وأصل القرار لملفه بالإدارة مع الأساس لملفه .</p>`;
};

export const deductionHtml = (dec, branding = {}) => {
  const school = branding.line3 || "";
  const managerName = (branding && branding.manager_name) || "..............................";
  const title = dec.title || "قرار حسم غياب";
  const body = dec.kind === "lateness" ? latenessPage(dec, school) : absencePage(dec, school);
  return `<!doctype html><html dir="rtl" lang="ar"><head><meta charset="utf-8">
<title>${esc(title)} — ${esc(dec.employee_name || "")}</title>
<link href="https://fonts.googleapis.com/css2?family=Amiri:wght@400;700&display=swap" rel="stylesheet">
<style>${DEDUCTION_STYLES}</style></head><body>

${brandHtml(branding)}

<h1 class="dtitle">${esc(title)}</h1>

<table class="box"><tr><td class="lbl">المدرسة</td><td>${esc(school)}</td></tr></table>
<table class="box"><tr><td class="lbl">رقم الهوية الوطنية</td>${civilBoxes((dec.employee_info || {}).employee_id || dec.employee_id)}</tr></table>

${body}
${signatureHtml(dec, branding, managerName)}

</body></html>`;
};
